export class CentroCostoRequest {
  id?: number;
  denominacion: string;
  centroCostoPadreId: number | null;
  numeroCuenta: number | null;

  constructor(data?: Partial<CentroCostoRequest>) {
    if (!data) return;

    this.id = data.id;
    this.centroCostoPadreId = data.centroCostoPadreId;
    this.denominacion = data.denominacion;
    this.numeroCuenta = data.numeroCuenta;
  }
}
